import React, { memo } from 'react'
import { Grid } from '@mui/material'

import BaseCard from '../shared/baseCard/BaseCard'
import Text from '../shared/text/Text'
import DefaultText from '../shared/text/DefaultText'

const Details = ({ t, rankingTable }) => {
  return (
    <BaseCard>
      <Text variant='h2' label={t('leaderboard.title')} fontWeight={700} />
      <DefaultText label={t('leaderboard.description')} />
      <Grid container spacing={6}>
        <Grid item xs={12}>
          {rankingTable}
        </Grid>
      </Grid>
    </BaseCard>
  )
}

export default memo(Details)
